import { defineStore } from 'pinia';
import { ref } from 'vue';
import { GeneralVolumeUnits, GeneralWeightUnits } from '@/constants/measurementUnits';

export const useUnitsStore = defineStore('units', () => {
  const importWeightUnit = ref<GeneralWeightUnits>(GeneralWeightUnits.KGS);
  const importVolumeUnit = ref<GeneralVolumeUnits>(GeneralVolumeUnits.CBM);

  const exportWeightUnit = ref<GeneralWeightUnits>(GeneralWeightUnits.LBS);
  const exportTotalVolumeUnit = ref<GeneralVolumeUnits>(GeneralVolumeUnits.CBM);
  const exportVolumeUnit = ref<GeneralVolumeUnits>(GeneralVolumeUnits.CFT);

  function setImportWeightUnit(unit: GeneralWeightUnits) {
    importWeightUnit.value = unit;
  }
  function setImportVolumeUnit(unit: GeneralVolumeUnits) {
    importVolumeUnit.value = unit;
  }
  function setExportWeightUnit(unit: GeneralWeightUnits) {
    exportWeightUnit.value = unit;
  }
  function setExportVolumeUnit(unit: GeneralVolumeUnits) {
    exportVolumeUnit.value = unit;
  }
  function setExportTotalVolumeUnit(unit: GeneralVolumeUnits) {
    exportTotalVolumeUnit.value = unit;
  }
  return {
    importWeightUnit,
    importVolumeUnit,
    exportWeightUnit,
    exportVolumeUnit,
    exportTotalVolumeUnit,
    setImportWeightUnit,
    setImportVolumeUnit,
    setExportWeightUnit,
    setExportVolumeUnit,
    setExportTotalVolumeUnit,
  };
});
